import { loadAppNetwork, loadIsOnline } from '.'
import {
  MobDataTypes,
  POS_APP_TYPES,
  PostAppTypes
} from '../../constants/MobAppConstants'

export function postDataToApp (type, payload) {
  try {
    const body = { type, payload }
    // if (type == PostAppTypes.OUTLET || type == PostAppTypes.REGISTER) {
    //   alert(body ? JSON.stringify(body) : 'ding ding')
    // }
    // window.sendDataToApp(body)
    window.ReactNativeWebView.postMessage(JSON.stringify(body))
  } catch (ex) {}
}

export function checkIsWeb () {
  let result = {
    // // default set web
    exist: true,
    type: 0
  }
  var val = localStorage.getItem('is_mob_app')
  if (val) {
    if (val == POS_APP_TYPES.RETAIL) {
      result.exist = false
      result.type = POS_APP_TYPES.RETAIL
    } else if (val == POS_APP_TYPES.REPORTING) {
      result.exist = false
      result.type = POS_APP_TYPES.REPORTING
    } else if (val == POS_APP_TYPES.SCANNER) {
      result.exist = false
      result.type = POS_APP_TYPES.SCANNER
    }
    return result
  } else {
    return result
  }
} 

export function isReportingApp(){
    return !checkIsWeb().exist && !checkIsWeb().type == POS_APP_TYPES.REPORTING
}

export function isPOSApp(){
  return !checkIsWeb().exist && !checkIsWeb().type == POS_APP_TYPES.RETAIL
}

export function isScannerApp(){
  return !checkIsWeb().exist && !checkIsWeb().type == POS_APP_TYPES.SCANNER
}